import { PropsWithChildren } from "react";

import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IHyperLinkProps {
    id?: string;
    dataCy?: string;
    target?: string;
    item?: any;
    key?: string;

    operation?: number;
    onChange?: () => void;
    text?: string;
    className?: string;

    marginTop?: string;
    marginLeft?: string;
    marginBottom?: string;
    marginRight?: string;

    IsUnderLined?: boolean;
    shouldOmitMargin?: boolean;
}

class HyperLinkControl extends React.Component<PropsWithChildren<IHyperLinkProps>, never> {
    public render(): JSX.Element {
        var self = this;
        var hyperlink;

        var marginTop = "0px";
        if (this.props.marginTop != null && this.props.marginTop != "")
            marginTop = this.props.marginTop;

        var marginLeft = "0px";
        if (this.props.marginLeft != null && this.props.marginLeft != "")
            marginLeft = this.props.marginLeft;

        var marginBottom = "0px";
        if (this.props.marginBottom != null && this.props.marginBottom != "")
            marginBottom = this.props.marginBottom;

        var marginRight = "0px";
        if (this.props.marginRight != null && this.props.marginRight != "")
            marginRight = this.props.marginRight;

        var margins = (marginTop + " " + marginRight + " " + marginBottom + " " + marginLeft);

        var s = {
            ...(!this.props.shouldOmitMargin && { margin: margins }),
            textDecoration: "none"
        };
        if (this.props.IsUnderLined === true) {
            s.textDecoration = "underline";
        }
        hyperlink = (<a id={self.props.id} className={this.props.className} style={s} onClick={this.onClick.bind(this)} data-cy={this.props.dataCy}> {this.props.text}{this.props.children} </a>);
        return (hyperlink);
    }

    public onClick(): void {
        if (this.props.operation != null) {
            var operation = new LocalEvent(this.props.operation);

            operation.AddItem("id", this.props.id);
            operation.AddItem("target", this.props.target);
            operation.AddItem("item", this.props.item);
            LocalEventDispatcher.dispatch(operation);
        }

        if (this.props.onChange != null) {
            this.props.onChange();
        }
    }
}

export { HyperLinkControl };
